import { makeStyles, type Theme } from "@material-ui/core";

export const useStyle = makeStyles((theme: Theme) => ({
  tooltip: {
    background: "#D9E7F0",
    color: "#235693",
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: "18px",
  },
  arrowToolTip: {
    color: "#D9E7F0",
  },
  scheduleButton: {
    background: "#0344DC",
    borderRadius: "100px",
    padding: "12px 24px",
    color: "white",
    fontSize: theme.typography.pxToRem(16),
    fontFamily: "Inter",
    fontWeight: 600,
    lineHeight: "22.4px",
    margin: "20px 0",
    border: "none",
    "&:hover": {
      color: "white",
      background: "#0344DC",
    },
    "&:disabled": {
      background: "#E6E6E6",
      color: "#666666",
    },
  },
}));
